// src/components/ui/Container.js
import React from 'react';
import { colors } from '../../styles/designSystem';

export const Container = ({ children, className = '', ...props }) => (
  <div
    className={`${colors.container.base} ${colors.container.hover} ${className}`}
    {...props}
  >
    {children}
  </div>
);